module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-presenter-f9588939aad9005c1283a1fb3664a8e0.jpg";